import * as tenantGroupSystemNames from '../data/tenantGroupSystemNames.json';
import { isTestZoneEnv } from '../libraries/EnvZone';
export const TransientReleaseToggles = (env, tenantId) => {
    if (!env) {
        throw new Error('Please provide ENV');
    }
    const activeEnv = (envs) => {
        return Boolean(envs.find((e) => e === '*' || env.startsWith(e)));
    };
    const activeTenants = (tenants) => {
        if (!tenantId) {
            console.log('WARNING! This should never happen. You cannot depend on tenant in a context where tenantId is undefined');
        }
        return Boolean(tenants.find((id) => id === '*' || id === tenantId));
    };
    const sunsetTenantIds = Object.keys(tenantGroupSystemNames.sunsetGroup).map((tenantId) => +tenantId);
    const bm20TenantIds = Object.keys(tenantGroupSystemNames.bm20Group).map((tenantId) => +tenantId);
    const sprintingSandboxTenantIds = Object.keys(tenantGroupSystemNames.sprintingSandbox).map((tenantId) => +tenantId);
    const sgTenantIds = [2, 3, 4, 5, 6];
    const isTestZone = () => isTestZoneEnv(env);
    const sgTenantsUpgraded = () => isTestZone() && activeTenants(sgTenantIds);
    return {
        testAllTenantsTransientReleaseToggle() {
            return isTestZone() && activeTenants(['*']);
        },
        testTransientReleaseToggle() {
            return isTestZone() && activeTenants(sunsetTenantIds);
        },
        marketingCardTransientToggle() {
            const envs = ['a-env', 'b-env', 'g-env'];
            return activeEnv(envs) && activeTenants(sunsetTenantIds);
        },
        productCatalogOptimization() {
            const SGConditions = activeEnv(['a-env', 'c-env', 'd-env', 't-env']) && activeTenants([2, 3, 5, 6]);
            const SBConditions = activeEnv(['c-env']) || activeTenants(sunsetTenantIds);
            return SBConditions || SGConditions;
        },
        reducingNumbersOfProductCatalogCalls() {
            const SBConditions = activeTenants(sunsetTenantIds);
            return SBConditions;
        },
        priceRulesJSONDataOptimization() {
            const SBConditions = activeTenants(sunsetTenantIds) && activeEnv(['a-env', 'b-env', 't-env', 'g-env']);
            return SBConditions;
        },
        isTenantVisible() {
            if (tenantId === 103) {
                return activeEnv(['b-env', 'd-spcloud-env', 'e-spcloud-env']);
            }
            return true;
        },
        enableNewProductCatalogPipeline() {
            return (activeTenants(sunsetTenantIds) ||
                activeTenants(sprintingSandboxTenantIds) ||
                activeTenants(bm20TenantIds) ||
                sgTenantsUpgraded());
        },
        enableProductCatalogObjectInMemoryCaching() {
            if (this.testAllTenantsTransientReleaseToggle()) {
                return false;
            }
            const envs = ['a', 'd', 't', 'e', 'g', 'o', 'q', 'p'];
            return activeEnv(envs);
        },
        enableProductCatalogReleaseOnDemand() {
            if (this.testAllTenantsTransientReleaseToggle()) {
                return false;
            }
            const envs = ['a', 'd', 't', 'e', 'g', 'o', 'q', 'p', 'k'];
            return (activeTenants(sunsetTenantIds) || activeTenants(bm20TenantIds)) && activeEnv(envs);
        },
        useInnerCoreGuard() {
            return activeTenants([600, 2]);
        },
        enableOrderLifecycleEvents() {
            return activeEnv(['d2-spcloud-env', 'k-spcloud-env', 'p-bm20-spcloud-env', 'b2-spcloud-env']);
        },
        muteTrivialLogs() {
            return activeEnv(['d2-spcloud-env', 'k-spcloud-env', 'p-bm20-spcloud-env', 'b2-spcloud-env']);
        },
    };
};
